@if (trackedLink) {
  <div class="pebl-dialog">
    <div class="pebl-dialog__header">
      <div class="pebl-dialog__header-main">
        <p class="pebl-dialog__eyebrow">Payment Link</p>
        <h1 class="pebl-dialog__amount">
          {{ trackedLink.amount / 100 | currency: trackedLink.currencyCodeIso }}
        </h1>
      </div>
      <button
        mat-icon-button
        class="pebl-dialog__close"
        [mat-dialog-close]
        data-test="tx-pebl-tracking-details-close-icon-button"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="pebl-dialog__badge-row">
      <span class="pebl-dialog__badge {{ statusBadgeClass() }}">
        <mat-icon>{{ statusIcon() }}</mat-icon>
        {{ statusText() }}
      </span>
      <span class="pebl-dialog__badge mon-bg-primary mon-text-primary">
        <mat-icon class="outline">{{ deliveryIcon() }}</mat-icon>
        {{ deliveryName() }}
      </span>
    </div>

    <mat-dialog-content class="pebl-dialog__body">
      <div class="pebl-dialog__section">
        <h2 class="pebl-dialog__section-title">Overview</h2>
        <div class="pebl-dialog__grid">
          <div class="pebl-dialog__item">
            <span class="pebl-dialog__label">Customer name</span>
            <p class="pebl-dialog__value">{{ trackedLink.name || '-' }}</p>
          </div>
          @if (trackedLink.delivery !== 'manual') {
            <div class="pebl-dialog__item">
              <span class="pebl-dialog__label">Sent to</span>
              <p class="pebl-dialog__value">
                {{
                  trackedLink.delivery === 'email'
                    ? trackedLink.emailAddress
                    : trackedLink.phoneNumber
                }}
              </p>
            </div>
          }
          <div class="pebl-dialog__item pebl-dialog__item--full">
            <span class="pebl-dialog__label">Description</span>
            <p class="pebl-dialog__value">{{ trackedLink.paymentDetail }}</p>
          </div>
          <div class="pebl-dialog__item">
            <span class="pebl-dialog__label">Created by</span>
            <p class="pebl-dialog__value">
              {{ trackedLink.operatorName || trackedLink.operatorEmail || '-' }}
            </p>
            @if (trackedLink.operatorName && trackedLink.operatorEmail) {
              <p class="pebl-dialog__value">{{ trackedLink.operatorEmail }}</p>
            }
          </div>
          <div class="pebl-dialog__item">
            <span class="pebl-dialog__label">Created</span>
            <p class="pebl-dialog__value">
              {{ trackedLink.linkCreated | date: 'dd/MM/yy HH:mm' }}
            </p>
          </div>
          @if (
            trackedLink.status !== 'Authorised' &&
            trackedLink.status !== 'Cancelled'
          ) {
            <div class="pebl-dialog__item">
              <span class="pebl-dialog__label">Expiry time</span>
              <p class="pebl-dialog__value {{ deliveryExpiryClass() }}">
                <mat-icon class="outline">{{ deliveryExpiryIcon() }}</mat-icon>
                @if (hasExpired()) {
                  <span
                    >Expired:
                    {{
                      (trackedLink.linkExpiration | date: 'dd/MM/yy HH:mm') ||
                        'N/A'
                    }}</span
                  >
                } @else {
                  <span
                    >{{ trackedLink.linkExpiration | relativeTime | titlecase }}
                    ({{
                      trackedLink.linkExpiration | date: 'dd/MM/yy HH:mm'
                    }})</span
                  >
                }
              </p>
            </div>
          }
          @if (trackedLink.status === 'Cancelled') {
            <div class="pebl-dialog__item pebl-dialog__item--full">
              <span class="pebl-dialog__label">Cancellation reason</span>
              <p class="pebl-dialog__value">
                {{ trackedLink.cancellationReason || '-' }}
              </p>
            </div>
          } @else if (trackedLink.status !== 'Authorised') {
            <div class="pebl-dialog__item pebl-dialog__item--full">
              <span class="pebl-dialog__label">Payment link</span>
              <p class="pebl-dialog__value">
                <mat-icon
                  [matTooltip]="'Copy Link'"
                  matTooltipPosition="right"
                  (click)="copyLink()"
                  class="outline interactable interactable-text"
                  >content_copy</mat-icon
                >
                <span class="pebl-dialog__link-value">{{ trackedLink.link }}</span>
              </p>
            </div>
          }
        </div>
      </div>

      @if (trackedLink.auditHistory && trackedLink.auditHistory.length > 0) {
        <div class="pebl-dialog__section">
          <h2 class="pebl-dialog__section-title">Attempt History</h2>
          <div class="pebl-dialog__audit-list">
            @for (event of trackedLink.auditHistory; track $index) {
              <div class="pebl-dialog__audit-item">
                <mat-icon class="outline {{ auditEventClass(event) }}">{{
                  auditEventIcon(event)
                }}</mat-icon>
                <div class="pebl-dialog__audit-body">
                  <p class="pebl-dialog__value {{ auditEventClass(event) }}">
                    {{ event.status || '-' }}
                  </p>
                  <span class="pebl-dialog__label">
                    {{ event.createdDate | date: 'dd/MM/yy HH:mm' }}
                    @if (event.message) {
                      {{ event.message }}
                    }
                  </span>
                </div>
                @if (hasAuditEventDetails(event)) {
                  <button
                    mat-stroked-button
                    class="pebl-dialog__audit-action bg-white-always mon-border-primary border mon-text-primary"
                    (click)="viewAuditEventTransaction(event)"
                    data-test="tx-pebl-tracking-details-audit-view-transaction-button"
                  >
                    View Details
                  </button>
                }
              </div>
            }
          </div>
        </div>
      }
    </mat-dialog-content>

    <div class="pebl-dialog__actions">
      @if (trackedLink.status !== 'Authorised') {
        @if (!hasExpired()) {
          <button
            mat-stroked-button
            class="mon-bg-danger mon-border-danger border mon-text-danger"
            [disabled]="actionButtonLoading || !GrantChecker()"
            (click)="CancelLink()"
            data-test="tx-pebl-tracking-details-cancel-link-button"
          >
            Cancel Link
          </button>
        } @else {
          <button
            mat-stroked-button
            class="mon-bg-primary mon-border-primary border mon-text-primary"
            [disabled]="actionButtonLoading || !GrantChecker()"
            (click)="ReinstateLink()"
            data-test="tx-pebl-tracking-details-reinstate-link-button"
          >
            Reinstate Link
          </button>
        }
      }
      <div class="pebl-dialog__actions-spacer"></div>
      <button
        mat-flat-button
        class="bg-white-always mon-border-primary border mon-text-primary"
        [mat-dialog-close]
        cdkFocusInitial
        data-test="tx-pebl-tracking-details-close-button"
      >
        Close
      </button>
    </div>
  </div>
}

<odin-loading-spinner
  [active]="actionButtonLoading"
  [overlay]="true"
></odin-loading-spinner>
